<template>
  <div>
    <nav-bar></nav-bar>
    <div id="allProducts"
         class="container-fluid">
      <div class="container">
        <div class="row pt-16">
          <div class="col-12 mx-auto pt-16">
            <span
                class="font-20 d-block text-center bold secondary-text">{{ $getText("HOME_PAGE_SERVICES_LIST_TITLE") }}</span>
            <span class="font-16 d-block pt-3 text-center ">{{ $getText("HOME-PAGE-SERVICES-LIST-DESC") }}</span>
          </div>
        </div>
        <div class="row pt-5">
          <div class="col-12">
            <span
                class="font-20 d-block text-center">{{ $getText("STARTUP-TITLE") }}</span>
          </div>
          <div v-for="item in products"
               :key="item.id" class="col-md-4 col-sm-6">
            <div class="light-bg p-3 text-center">
              <router-link :to="{path:'AllProductDetail', query:{AllProductID:item.id}}"
                           class=" round10px pointer">
                <img :src="getImgUrl('allProject/'+ item.imageRoot + '/main.jpg')" :alt="item.name"
                     class="img-fluid">
                <h6 class="font-weight-bold py-2 pointer secondary-text">
                  {{ item.title }}
                </h6>
                <span class="text-over-flow black--text">
                        {{ item.desc }}
                    </span>
              </router-link>
            </div>
          </div>
        </div>

      </div>
    </div>
    <footer-pages></footer-pages>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import FooterPages from "@/components/FooterPages";

export default {
  name: "AllProducts",
  metaInfo: {
    title: 'ایزیسیس طراحی وب سایت اپلیکیشن موبایل و استارت اپ-نمونه تولیدات'
  },
  components: {FooterPages, NavBar},
  data: () => ({
    title: "نمونه تولیدات",
    products: [],
    websites: [],
  }),
  mounted() {
    this.$getText()
    this.$setCssFiles();


    this.products = this.$getAllProjects();


  },
  methods: {
    getImgUrl(pic) {
      return require('../assets/img/' + pic)
    },
  }
}
</script>

<style scoped>

</style>
